// extracted by mini-css-extract-plugin
export default {"base":"EditNotifications_base__8tO08"};